import Container from '../../atoms/container/emptyCardContainer';
import Image from '../../atoms/images/horizontalCardImage';
import { RailDisplayMode } from '@shared/types/enums/rail';

function EmptyCard({ displayMode }: { displayMode: RailDisplayMode }) {
  return (
    <>
      <Container displayMode={displayMode}>
        <Image />
        {'Sin resultados'}
      </Container>
    </>
  );
}

export default EmptyCard;
